import { useState, useEffect } from "react"
import FaxList from "../components/faxList"
import QueueList from "../components/queueList"
import FolderManagement from "../components/folderManagement"
import { get, post } from "./../utils/apiClient"
import FormsLogo from "../images/efax.svg"
import "../css/style.css"
import Cookies from "js-cookie"
import { Settings, User } from "lucide-react"
import { PERSONAL_FAX } from "./../utils/constants"

const tabs = [
  {
    key: "inbound",
    label: "Inbound",
    icon: (color) => <Settings size={18} color={color} />,
  },
  {
    key: "outbound",
    label: "Outbound",
    icon: (color) => <Settings size={18} color={color} />,
  },
  {
    key: "setting",
    label: "Settings",
    icon: (color) => <Settings size={18} color={color} />,
  },
]

const Dashboard = ({ authUser }) => {
  const [selectedFax, setSelectedFax] = useState(null)
  const [tab, setTab] = useState("inbound")
  const [selectedQueue, setSelectedQueue] = useState(null)
  const [selectedFolderMng, setSelectedFolderMng] = useState(null)
  const [queueList, setQueueList] = useState([])
  const [appLoading, setAppLoading] = useState(true)
  const [allPermissions, setAllPermissions] = useState(null)
  const [reloadSubfolderCount, setReloadSubfolderCount] = useState(null)

  const fetchQueues = async () => {
    try {
      const data = (await get("/admin/musc/netId/overview")) || []

      setQueueList(data)
      setAllPermissions(data.globalPermissionTemplate)
      setAppLoading(false)
    } catch (error) {
      console.error("Failed to fetch applications", error)
      setAppLoading(false)
    }
  }

  const handleLogout = async () => {
    try {
      Cookies.remove("user")
      await post(`/oauth/logout`)
      window.location.href = "/"
    } catch (err) {
      console.error("Error in handleLogout:", err)
    }
  }

  const loadQueues = async () => {
    setAppLoading(true)
    fetchQueues()
  }

  useEffect(() => {
    setSelectedFax(null)

    if (!["inbound", "outbound"].includes(tab)) {
      setSelectedFax(null)
      setSelectedQueue(null)
    }

    if (
      (selectedQueue?.faxNumber === PERSONAL_FAX ||
        selectedQueue?.parentKey === "userPersonalFax") &&
      tab === "inbound"
    ) {
      setTab("outbound")
    } else if (selectedQueue?.type === "subfolder" && tab === "outbound") {
      setTab("inbound")
    }
  }, [selectedQueue, tab])

  useEffect(() => {
    loadQueues()
    setSelectedQueue(null)
    setSelectedFax(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="container">
      <div className="header-container">
        {/* <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
        </div> */}

        <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
          <div
            className="logo-label"
            style={{ color: "#FF0000", padding: "0px 5px" }}
          >
            |
          </div>
          <div className="logo-label">MUSC Custom Fax Manager</div>
        </div>

        <div className="user-container">
          <User size={16} style={{ marginRight: "4px", verticalAlign: "middle" }} />{authUser?.emailAddress} |{" "}
          <span className="logout-link" onClick={() => handleLogout()}>
            Logout
          </span>
        </div>
      </div>

      <div className="container-fax">
        <div
          className={`document-list ${
            selectedFolderMng || tab === "setting" ? `locked` : ""
          }`}
        >
          <QueueList
            data={queueList}
            appLoading={appLoading}
            selectedQueue={selectedQueue}
            setSelectedQueue={setSelectedQueue}
            authUser={authUser}
            // tab={tab}
            loadQueues={loadQueues}
            setSelectedFolderMng={setSelectedFolderMng}
            allPermissions={allPermissions}
            reloadSubfolderCount={reloadSubfolderCount}
            setReloadSubfolderCount={setReloadSubfolderCount}
          />
        </div>

        {selectedFolderMng ? (
          <FolderManagement
            selectedFolderMng={selectedFolderMng}
            setSelectedFolderMng={setSelectedFolderMng}
          />
        ) : (
          <FaxList
            selectedFax={selectedFax}
            selectedQueue={selectedQueue}
            setSelectedQueue={setSelectedQueue}
            setSelectedFax={(fax) => setSelectedFax(fax)}
            tab={tab}
            setTab={setTab}
            tabs={tabs}
            //setReloadUsers={(flg) => setReloadUsers(flg)}
            authUser={authUser}
            reloadQueues={() => fetchQueues()}
            queueList={queueList}
            allPermissions={allPermissions}
            setReloadSubfolderCount={setReloadSubfolderCount}
          />
        )}
      </div>
      {/* )} */}
    </div>
  )
}

export default Dashboard
